import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';

import store from '../store';

// import Custom Components
import Header from './common/header';
import Footer from './common/footer';
import MobileMenu from './common/mobile-menu';

// import Utils
import { mobileMenu, preventProductDefault, removePreventProductDefault, stickyHeaderHandler } from '../utils';
import { closeQuickViewModal } from '../actions';

function App(props) {
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    mobileMenu();

    // set sticky header
    stickyHeaderHandler();
    window.addEventListener('scroll', stickyHeaderHandler, true);

    // prevent product thumb icons
    preventProductDefault();

    return () => {
      window.removeEventListener('scroll', stickyHeaderHandler);

      // remove listeners of prevent product
      removePreventProductDefault();
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      document.body.classList.add("loaded");
      document.getElementById("root").classList.add("loaded");
    }, 200);

    // const children = Array.isArray(props.children) ? props.children : [props.children];
    // const matchedCount = children.some(child => {
    //   const childPath = child.props.path;
    //   return pathname === childPath;
    // });

    // if (!matchedCount) {
    //   window.location = process.env.PUBLIC_URL + "/pages/404";
    // }

    if (store.getState()?.data?.quickView) {
      store.dispatch(closeQuickViewModal());
    }
  }, [pathname, props.children]);

  return (
    <>
      <div className="page-wrapper">
        <Header />

        {props.children}

        <Footer />

        <ToastContainer autoClose={3000} className="toast-container" />
      </div>

      <MobileMenu />
    </>
  );
}

export default App;
